import React from "react";
import "./Common_Title.css";

const Common_Title = ({ title, subTitle }) => {
  return (
    <div className="Common_Title">
      <h4>
        {title}
        {subTitle && <span className="inner_text">{subTitle}</span>}
      </h4>
    </div>
  );
};

export default Common_Title;